import HeatmapProvider from '../providers/HeatmapProvider'

var HeatmapService = function () {
  return {
    GetHeatmap: function (railobjectId, linear, dateFrom, dateTo, progressCallback) {
      return HeatmapProvider.GetHeatmap(railobjectId, linear, dateFrom, dateTo, progressCallback)
    }
  }
}

export default new HeatmapService()



// WEBPACK FOOTER //
// ./src/services/HeatmapService.js